module.exports = __webpack_public_path__ + "static/media/arrow-button-left-on-2.e059225c.svg";